import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../actions/userAction";
import Message from "./Message";

const HireServiceHero = ({ service }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("employer");

  const dispatch = useDispatch();

  const history = useHistory();

  const userRegister = useSelector((state) => state.userRegister);
  const { loading, error, userInfo } = userRegister;

  useEffect(() => {
    if (userInfo) {
      history.push("/employer/request");
    }
  }, [history, userInfo]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(register(name, email, password, role, history));
  };

  const togglePassword = () => {
    setOpen(!open);
  };
  console.log(service);

  return (
    <section className="hirehero py-5 container">
      {error && <Message variant="danger">{error}</Message>}
      <div className="row align-items-center no-gutters justify-content-between">
        <div className="col-md-6 col-sm-12">
          <h2 className="lh-small font-subhead py-3 pb-25 text-white text-capitalise">
            {service[0].name}
          </h2>
          <div className="font-normal"
            dangerouslySetInnerHTML={{
              __html: service[0].content,
            }}></div>
        </div>
        <div className="col-md-5 col-sm-12 pt-3">
          <div className="form-wrapper shadow-lg p-2 px-3">
            <h3 className="lh-small mb-25 font-medium text-white text-center">
              Make a Request
            </h3>
            <p className="text-center font-sm">
              Guaranteed response within one business day!
            </p>
            <form onSubmit={submitHandler} className="w-100 mt-3">
              <div className="mb-2">
                <div className="input">
                  <input
                    type="text"
                    value={name}
                    placeholder="John Doe"
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="mb-2">
                <div className="input">
                  <input
                    type="email"
                    value={email}
                    placeholder="Joh@email.com"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="mb-2">
                <div className="input">
                  <input
                    type={open ? "text" : "password"}
                    value={password}
                    placeholder="password"
                    onChange={(e) => setPassword(e.target.value)}
                    minlength="5"
                    required
                  />
                  <div className="pointer" onClick={togglePassword}>
                    {open ? (
                      <i class="fas fa-eye-slash"></i>
                    ) : (
                      <i class="fas fa-eye"></i>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-1 d-none">
                <div className="input">
                  <input type="hidden" value={role} />
                </div>
              </div>
              <div className="my-3">
                <button
                  className="d-flex justify-content-center bg-blue"
                  type="submit">
                  {loading ? <div className="spinner"></div> : "SIGN UP"}
                </button>
              </div>
            </form>
            <p className="text-center mb-25 font-sm">
              By creating an account, I agree to the{" "}
              <Link to="">Terms of Service</Link> and{" "}
              <Link to="">Privacy Policy</Link>.
            </p>
            <p className="text-center mb-25 font-sm">
              Already have an account? <Link to="/login">Log in</Link>
            </p>
            {/* <p className="text-center">
              <Link to="/developer/signup">Apply As a Developer</Link>
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HireServiceHero;
